"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _cccisdLaravelLicensing = require("cccisd-laravel-licensing");
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
var _manage = _interopRequireDefault(require("./manage.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Appdefs = window.cccisd.appDefs;
var Manage = /*#__PURE__*/function (_React$Component) {
  _inherits(Manage, _React$Component);
  function Manage() {
    var _this;
    _classCallCheck(this, Manage);
    _this = _callSuper(this, Manage);
    _this.state = {};
    return _this;
  }
  _createClass(Manage, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        externalLoadData = _this$props.externalLoadData,
        tabWidths = _this$props.tabWidths,
        verticalNav = _this$props.verticalNav,
        verticalNavClass = _this$props.verticalNavClass,
        products = _this$props.products,
        productHandle = _this$props.productHandle;

      // filter down to a single product if specified
      if (productHandle) {
        products = products.filter(function (p) {
          return p.handle === productHandle;
        });
      } else if ('match' in this.props && this.props.match.params.productHandle) {
        products = products.filter(function (p) {
          return p.handle === _this2.props.match.params.productHandle;
        });
      }

      // don't try to manage licenses unless theres a role attached to that product
      products = products.filter(function (p) {
        return p.roleList.length;
      });

      // only allow licenses on groups where descendant pawns have a product
      var groupsWithLicenses = {}; // in form of { groupHandle: [productIds] }
      function addGroupWithLicenses(groupHandle, productId) {
        var groupDef = Appdefs.pawn.groups.find(function (g) {
          return g.handle === groupHandle;
        });
        if (groupDef && (!groupsWithLicenses[groupHandle] || !groupsWithLicenses[groupHandle].includes(productId))) {
          Array.isArray(groupsWithLicenses[groupHandle]) ? groupsWithLicenses[groupHandle].push(productId) : groupsWithLicenses[groupHandle] = [productId];
          groupDef.parentGroups.forEach(function (parent) {
            return addGroupWithLicenses(parent, productId);
          });
        }
      }
      products.forEach(function (product) {
        return product.roleList.forEach(function (role) {
          var roleDef = Appdefs.pawn.roles.find(function (r) {
            return r.handle === role.handle;
          });
          var parentGroups = roleDef.membersOf;
          parentGroups.forEach(function (groupHandle) {
            return addGroupWithLicenses(groupHandle, product.productId);
          });
        });
      });
      var tabList = [];
      verticalNav.forEach(function (v, index) {
        /* To show licensing, verticalNav must have handle that
            matches one of the group or role handles exactly. */
        var productsProp = [];
        if (v.contentConfig.nexusType === 'pawn') {
          productsProp = products.filter(function (p) {
            return p.roleList.some(function (r) {
              return r.handle === v.handle;
            });
          });
        } else if (v.contentConfig.nexusType === 'group' && Array.isArray(groupsWithLicenses[v.handle])) {
          productsProp = products.filter(function (p) {
            return groupsWithLicenses[v.handle].includes(p.productId);
          });
        }
        tabList.push({
          name: v.handle,
          title: v.label,
          content: /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.RosteringContainer, {
            key: index,
            tabHandle: v.handle,
            content: v.contentConfig,
            externalLoadData: externalLoadData,
            products: productsProp
          })
        });
      });

      // if you don't have a group, you have no high-level licenses to manage
      var actingGroup = Fortress.user.acting.group;
      var isManageGroupLicenses = actingGroup && groupsWithLicenses[actingGroup.data_type];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_manage["default"].appdefsManage, ' appdefs-manage')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _manage["default"].pageTop
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.pageTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription), isManageGroupLicenses && /*#__PURE__*/_react["default"].createElement("span", {
        className: _manage["default"].manageHeldLicenses
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelLicensing.GroupLicenseButton, {
        products: products.filter(function (p) {
          return groupsWithLicenses[actingGroup.data_type].includes(p.productId);
        })
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_defineProperty({}, "".concat(_cccisdStyleBible["default"][verticalNavClass]), verticalNavClass ? true : false))
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
        tabList: tabList,
        orientation: "vertical",
        saveInHash: true,
        verticalTabWidths: tabWidths
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix"
      })));
    }
  }]);
  return Manage;
}(_react["default"].Component);
_defineProperty(Manage, "propTypes", {
  verticalNav: _propTypes["default"].array,
  verticalNavClass: _propTypes["default"].string,
  pageTitle: _propTypes["default"].string,
  pageDescription: _propTypes["default"].string,
  tabWidths: _propTypes["default"].object,
  externalLoadData: _propTypes["default"].func,
  products: _propTypes["default"].array,
  productHandle: _propTypes["default"].string,
  match: _propTypes["default"].object
});
_defineProperty(Manage, "defaultProps", {
  verticalNavClass: null,
  tabWidths: {
    left: 3,
    right: 9
  },
  products: []
});
var _default = exports["default"] = (0, _cccisdLaravelLicensing.getProducts)(Manage);